import { Divider, Text } from '@wework/dieter-ui'
import parseISO from 'date-fns/parseISO'
import format from 'date-fns/format'
import React from 'react'
import History from './History'

export default function EditHistory({ history }) {
  if (!history) {
    return null
  }
  return (
    <div>
      {history.map((change, index) => {
        return (
          <>
            <Text style={{ fontWeight: 'bold' }} size="small">
              {format(parseISO(change.created_at), 'MMMM dd, yyyy')}
            </Text>
            {change.data_changed.map((value, index) => {
              return (
                <History
                  attribute={value}
                  created_at={change.created_at}
                  fullname={change.fullname}
                />
              )
            })}
            <Divider />
          </>
        )
      })}
    </div>
  )
}
